import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './firebaseConfig';
import Questionarios from './Questionarios';
import Resultados from './Resultados';
import Perguntas from './Perguntas';
import VisualizarQuestionario from './VisualizarQuestionario';
import EditarQuestionario from './EditarQuestionario';
import ResponderQuestionario from './ResponderQuestionario';
import Login from './Login';
import VersionChecker from './VersionChecker';
import AppShell from './AppShell';
import './App.css';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      await auth.authStateReady();
      if (cancelled) return;
      const user = auth.currentUser;
      const loggedIn = Boolean(user && !user.isAnonymous);
      if (loggedIn) {
        localStorage.setItem('isAuthenticated', 'true');
      } else {
        localStorage.removeItem('isAuthenticated');
      }
      setIsAuthenticated(loggedIn);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
  };

  const handleLogout = async () => {
    if (window.confirm('Deseja realmente sair?')) {
      try {
        await signOut(auth);
        localStorage.removeItem('isAuthenticated');
        setIsAuthenticated(false);
        navigate('/login');
      } catch (error) {
        console.error('Erro ao fazer logout:', error);
      }
    }
  };

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner-large" />
        <p>Carregando...</p>
      </div>
    );
  }

  const showShell =
    isAuthenticated && !location.pathname.startsWith('/responder-questionario');

  const routes = (
    <Routes>
      <Route path="/responder-questionario/:id" element={<ResponderQuestionario />} />
      <Route path="/login" element={<Login onLogin={handleLogin} />} />

      {isAuthenticated ? (
        <>
          <Route path="/" element={<Questionarios />} />
          <Route path="/resultados" element={<Resultados />} />
          <Route path="/criar-questionario" element={<Perguntas />} />
          <Route path="/perguntas" element={<Perguntas />} />
          <Route path="/questionario/:id" element={<VisualizarQuestionario />} />
          <Route path="/editar-questionario/:id" element={<EditarQuestionario />} />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
    </Routes>
  );

  return (
    <div className="app">
      <VersionChecker />
      {showShell ? (
        <AppShell onLogout={handleLogout}>{routes}</AppShell>
      ) : (
        routes
      )}
    </div>
  );
};


// Wrapping App inside Router to use useLocation
const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
